import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@superops/ui-design-system';

interface PromptInputSectionProps {
  onCreatePrompt?: (promptText: string) => void;
  isLoading?: boolean;
  clearInput?: boolean;
}

export const PromptInputSection: React.FC<PromptInputSectionProps> = ({
  onCreatePrompt,
  isLoading = false,
  clearInput = false
}) => {
  const [promptText, setPromptText] = useState('');

  useEffect(() => {
    if (clearInput) {
      setPromptText('');
    }
  }, [clearInput]);

  const handleCreatePrompt = () => {
    if (!promptText.trim() || isLoading) return;

    console.log('Creating prompt with text:', promptText);
    if (onCreatePrompt) {
      onCreatePrompt(promptText);
    }
  };

  return (
    <div className="bg-newblack p10 br-5 mb10 flex col">
      <div>
        <TextField
          multiline
          bgTransparent
          placeholder="Enter few words to create a prompt"
          value={promptText}
          onChange={(val) => setPromptText(val)}
          label=""
          autoComplete="off"
        />
      </div>
      <div className="flex jend">
        <Button
          aiPrimary
          size="slim"
          onClick={handleCreatePrompt}
          disabled={isLoading || !promptText.trim()}
        >
          <div className="fsize12">
            {isLoading ? 'Creating...' : 'Create Prompt'}
          </div>
        </Button>
      </div>
    </div>
  );
};
